import { SagaIterator } from "redux-saga"
import { put } from "redux-saga/effects"
import { AxiosError } from "axios"
import { notifyIfServerError } from "../utils"

type ErrorHandlerArgs = {
  error: AxiosError
  endpoint?: string
  service?: string
}

export function* handleError(payload: ErrorHandlerArgs): SagaIterator {
  const { error, endpoint, service } = payload
  if (Array.isArray(error)) {
    for (const e of error) {
      yield put(notifyIfServerError({ error: e }))
    }
    return
  }
  yield put(notifyIfServerError({ error, endpoint, service }))
}
